<ng-container *ngIf="kpiRealtorShare">
  <h2 class="offset-1 text-white mb-3 mt-3 text-white">Partages</h2>
  <div class="row">
    <div [class]="cardClass">
      <app-kpi
        icon="share"
        title="Actifs"
        [value]="kpiRealtorShare.active"
      ></app-kpi>
    </div>
    <div [class]="cardClass">
      <app-kpi
        icon="person_add_alt"
        title="Créés"
        details="Ces 30 derniers jours"
        [value]="kpiRealtorShare.created"
      ></app-kpi>
    </div>
    <div [class]="cardClass">
      <app-kpi
        icon="percent"
        title="Taux de consultation"
        details="Ces 30 derniers jours"
        [value]="kpiRealtorShare.consultationRate"
      ></app-kpi>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="kpiRealtorProperty">
  <h2 class="offset-1 text-white mb-3 mt-3 text-white">Biens</h2>
  <div class="row">
    <div [class]="cardClass">
      <app-kpi
        icon="house"
        title="Biens enregistrés"
        [value]="kpiRealtorProperty.total"
      ></app-kpi>
    </div>
    <div [class]="cardClass">
      <app-kpi
        icon="real_estate_agent"
        title="Biens à vendre"
        [value]="kpiRealtorProperty.toSale"
      ></app-kpi>
    </div>
    <div [class]="cardClass">
      <app-kpi
        icon="currency_exchange"
        title="Ventes en cours"
        [value]="kpiRealtorProperty.onGoingSales"
      ></app-kpi>
    </div>
    <div [class]="cardClass">
      <app-kpi
        icon="attach_money"
        title="Ventes signées"
        [value]="kpiRealtorProperty.signedSales"
        [main]="true"
      ></app-kpi>
    </div>
    <div [class]="cardClass">
      <app-kpi
        icon="money_off"
        title="Ventes annulées"
        [value]="kpiRealtorProperty.canceledSales"
      ></app-kpi>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="kpiRealtorContact">
  <h2 class="offset-1 text-white mb-3 mt-3 text-white">Contacts</h2>
  <div class="row">
    <div [class]="cardClass">
      <app-kpi
        icon="people_alt"
        title="Total"
        [value]="kpiRealtorContact.total"
      ></app-kpi>
    </div>
    <div [class]="cardClass">
      <app-kpi
        icon="person"
        title="Particuliers"
        [value]="kpiRealtorContact.individual"
      ></app-kpi>
    </div>
    <div [class]="cardClass">
      <app-kpi
        icon="how_to_reg"
        title="Notaires"
        [value]="kpiRealtorContact.notary"
      ></app-kpi>
    </div>
    <div [class]="cardClass">
      <app-kpi
        icon="badge"
        title="Agents"
        [value]="kpiRealtorContact.realtor"
      ></app-kpi>
    </div>
  </div>
</ng-container>
